module.exports = __webpack_public_path__ + "/templates/components/sections/travel-info[2020].twig";